/**
 * The login address that brings the person back to the page they were sent
 * to, typically by a button in one of our mails. Without it they land on the
 * dashboard after signing in and have to find the request or unit themselves.
 *
 * The login page only follows paths on this portal, so a link from outside
 * cannot turn this into a way off the site.
 */
export const loginPathFor = (location: {
    pathname: string;
    search?: string;
    hash?: string;
}): string => {
    const { pathname, search = "", hash = "" } = location;
    // An expired session sends here twice in a row: the route guard as soon as
    // the stores are cleared, then the session check. The second call finds
    // the login already open and has to keep its way back, not drop it.
    if (pathname.startsWith("/login")) {
        return `${pathname}${search}`;
    }
    if (!pathname || pathname === "/" || pathname === "/dashboard") {
        return "/login";
    }
    return `/login?redirect=${encodeURIComponent(`${pathname}${search}${hash}`)}`;
};
